// TODO: Readme here
// * District send province_code to get all district
// * Tambon send province_code, district_code to get all tambon

import { Save } from "@mui/icons-material";

//// old path = https://prd-digital-certificate.one.th
// local
// export const BASE_URL = 'http://localhost:3000';
// dev
// export const BASE_URL = 'https://dev-dcert.one.th';
// uat
// export const BASE_URL = 'https://uat-dcert.one.th';
export const BASE_URL = 'https://uat-ecredential.one.th';
// prd
// export const BASE_URL = 'https://prd-digital-certificate.one.th';

/*
    SKIP PORTAL
    - login
    - signPDF
*/

// APIEndPoint
export const APIEndpoint = {
    // ใช้ Login
    Login: `${BASE_URL}/api/v1/login/token`,
    NavigationLogin: `${BASE_URL}/`,
    Register: `${BASE_URL}/api/v1/register/member`,
    RegisterPerson: `${BASE_URL}/api/v1/portal/provider/register-person`,
    RegisterStaff: `${BASE_URL}/api/v1/portal/provider/register-staff`,
    DiagnosticPerson: `${BASE_URL}/api/v1/portal/person`,
    SignMedCert: `${BASE_URL}/api/v1/portal/vc`,
    GetMedCertDataByDocID: `${BASE_URL}/api/v1/portal/vc/data?document_id=`,
    SingDialogSendToApi: `${BASE_URL}/api/v1/portal/digital-signature-image`,
    DigitalSignatureImage: `${BASE_URL}/api/v1/portal/digital-signature-image`,
    Province: `${BASE_URL}/api/v1/portal/address/all-province`,
    District: `${BASE_URL}/api/v1/portal/address/all-district`,
    Tambol: `${BASE_URL}/api/v1/portal/address/all-tambon`,
    DoctorName: `${BASE_URL}/api/v1/portal/person/filter-by-hospital-code?hospital_code=`,
    Department: `${BASE_URL}/api/v1/portal/department/all`,
    Gender: `${BASE_URL}/api/v1/portal/gender/all`,
    Prefix : `${BASE_URL}/api/v1/portal/prefix/all`,
    PrefixPatient: `${BASE_URL}/api/v1/portal/prefix/patient`,
    GetAllCertType: `${BASE_URL}/api/v1/vc/type?hospital_code=DB605`,
    GetStatusAll: `${BASE_URL}/api/v1/portal/report/status/total`,
    GetBase64: `${BASE_URL}/api/v1/portal/report/base64`,
    DeleteDocument: `${BASE_URL}/api/v1/portal/vc/delete`,
    GetDocument: `${BASE_URL}/api/v1/portal/vc/data?document_id=`,
    SaveDocument: `${BASE_URL}/api/v1/vc`,
    // EditDocument: `${BASE_URL}/api/v1/portal/vc/data?document_id=`,
    // register-person `${BASE_URL}/api/v1/portal/provider/register-person`
};

// * FOR DEV RIGHT NOW 19/9/2024
export const BasicAuthUser = {
    username: 'LKPkpasspOkpokpO',
    password: 'OPKpaPOakskchyu',
};
  